<template>
    <div>
      <div class="title-top-alarm">
        <div>
          <span>{{commObj.openTitle}}</span>
        </div>
        <div class="line-title"></div>
      </div>
      <el-form :model="addCommunityForm" :rules="addCommunityRules" ref="addCommunityForm" label-width="110px" class="demo-ruleForm">
        <div style="margin: 10px 70px 0 40px">
          <el-row v-if="moduletag === 3">
            <el-col :span="12">
              <el-form-item label="小区/机构" prop="zone_type">
                <el-select v-fixZoom style="width: 100%" :disabled="isHomeAdd" v-model="addCommunityForm.zone_type" placeholder="请选择">
                  <el-option
                    v-for="item in zoneTypes"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-if="addCommunityForm.zone_type === ''" label="小区/机构名称" prop="name">
                <el-input v-model="addCommunityForm.name" placeholder="请输入小区/机构名称"></el-input>
              </el-form-item>
              <el-form-item v-if="addCommunityForm.zone_type === 1" label="小区名称" prop="name">
                <el-input v-model="addCommunityForm.name" placeholder="请输入小区名称"></el-input>
              </el-form-item>
              <el-form-item v-if="addCommunityForm.zone_type === 2" label="机构名称" prop="name">
                <el-input v-model="addCommunityForm.name" placeholder="请输入机构名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item v-if="moduletag === 1" label="小区名称" prop="name">
            <el-input v-model="addCommunityForm.name" placeholder="请输入小区名称"></el-input>
          </el-form-item>
          <el-form-item v-if="moduletag === 2" label="机构名称" prop="name">
            <el-input v-model="addCommunityForm.name" placeholder="请输入机构名称"></el-input>
          </el-form-item>
          <el-form-item label="所属组织" prop="orgid">
            <el-cascader v-fixZoom
              style="width: 100%"
              :options="orgOptions"
              v-model="addCommunityForm.orgid"
              :filterable="true"
              placeholder="请选择所属组织"
              :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
              ref="orgOptions">
            </el-cascader>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input v-model="addCommunityForm.address"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="经度" prop="lng">
                <el-input type="number" v-model="addCommunityForm.lng" @blur="sendMarkerLng()"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="纬度" prop="lat">
                <el-input type="number" v-model="addCommunityForm.lat" @blur="sendMarkerLat()"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div style="z-index: 9999;margin: 0 10px">
          <el-autocomplete v-fixZoom style="width: 100%" class="inline-input" v-model="searchAddress"
            :fetch-suggestions="querySearch" placeholder="关键词搜索" :trigger-on-focus="false" @select="handleSelect" @blur="changeAddress"></el-autocomplete>
        </div>
        <div style="margin: -45px 10px 0;height: 300px;">
          <iframe id="mainIframe" ref="mainIframe" name="mainIframe" style="width: 100%;height: 100%;margin: auto" src="../../../../static/addressMap.html" frameborder="0" scrolling="no"></iframe>
        </div>
      </el-form>
      <div style="margin-top: 15px">
        <el-row style="margin: 0 30px">
          <el-col :span="12">
            <div class="cancel-btn" @click="closeAddEdit()">
              <span>取消</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="submitAddEdit('addCommunityForm')">
              <span>确定</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="height: 15px"></div>
    </div>
</template>

<script>
// import AMapLoader from '@amap/amap-jsapi-loader'
import {addorgcommunity, updateorgcommunity} from '../../../api/community'

export default {
  name: 'communityAddEdit',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    commObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isAdd: true,
      row: {},
      orgOptions: [],
      zoneTypes: [
        {name: '小区', id: 1},
        {name: '机构', id: 2}
      ],
      searchAddress: '',
      addCommunityForm: {
        id: 0,
        address: '',
        lng: '',
        lat: '',
        orgid: '',
        zone_type: '',
        name: ''
      },
      addCommunityRules: {
        zone_type: [
          { required: true, message: '请选择小区/机构', trigger: 'change' }
        ],
        orgid: [
          { required: true, message: '请选择所属组织', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入小区名称', trigger: 'blur' }
        ],
        lng: [
          { required: true, message: '请输入经度', trigger: 'blur' }
        ],
        lat: [
          { required: true, message: '请输入纬度', trigger: 'blur' }
        ]
      },
      // 地图
      map: '',
      markers: [],
      // AMap: '',
      autoComplete: '',
      moduletag: '',
      isHomeAdd: false
    }
  },
  created () {
    /* 1 relationAdd.vue 新增家庭页面 2 community.vue 小区/机构管理 */
    console.log(999, this.commObj)
    this.moduletag = this.$store.state.user.moduletag
    if (this.moduletag === 1) {
      this.addCommunityForm.zone_type = 1
    } else if (this.moduletag === 2) {
      this.addCommunityForm.zone_type = 2
    }
    this.golobleObject.sendIsAdd = this.getIsAdd
    this.getTreeData()
    this.isAdd = this.commObj.isAdd
    if (!this.commObj.isAdd) {
      this.row = this.commObj.row
      this.addCommunityForm.id = this.row.id
      this.addCommunityForm.address = this.row.address
      this.addCommunityForm.lng = this.row.lng
      this.addCommunityForm.lat = this.row.lat
      this.addCommunityForm.orgid = this.row.orgid
      this.addCommunityForm.name = this.row.name
      this.addCommunityForm.zone_type = this.row.zone_type
    }
    if (this.commObj.type === '0') { // 小区
      this.isHomeAdd = true
      this.addCommunityForm.zone_type = 1
    } else if (this.commObj.type === '1') { // 机构
      this.isHomeAdd = true
      this.addCommunityForm.zone_type = 2
    } else {
      this.isHomeAdd = false
    }
  },
  mounted () {},
  methods: {
    // 所属组织
    getTreeData () {
      // console.log(this.commObj)
      // 所属组织
      let lastLevel = 100
      let arr = []
      if (this.commObj.orgids.length === 0) {
        arr = this.commObj.orgTree
      } else {
        for (let i = 0; i < this.commObj.orgTree.length; i++) {
          if (this.commObj.orgids.indexOf(this.commObj.orgTree[i].id) > -1) {
            arr.push(this.commObj.orgTree[i])
          }
        }
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level < lastLevel) {
          lastLevel = arr[i].level
        }
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          this.orgOptions.push(arr[i])
        }
      }
      for (let i = 0; i < this.orgOptions.length; i++) {
        const child = this.arrayToNode(arr, this.orgOptions[i].id)
        if (child.length !== 0) {
          this.orgOptions[i].child = child
        }
      }
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    querySearch (queryString, cb) {
      this.autoComplete.search(queryString, function (status, result) {
        let re = []
        for (let i = 0; i < result.tips.length; i++) {
          let obj = {
            lng: result.tips[i].location.lng,
            lat: result.tips[i].location.lat,
            value: result.tips[i].district + result.tips[i].name
          }
          re.push(obj)
        }
        cb(re)
        // 搜索成功时，result即是对应的匹配数据
        // console.log('result', result)
      })
    },
    handleSelect (item) {
      console.log(item)
      this.addCommunityForm.lng = item.lng
      this.addCommunityForm.lat = item.lat
      if (this.addCommunityForm.address === '') {
        this.addCommunityForm.address = item.value
      }
      this.selectMarker(item)
    },
    changeAddress () {
      if (this.addCommunityForm.address === '') {
        this.addCommunityForm.lng = ''
        this.addCommunityForm.lat = ''
      }
    },
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            let data = {
              id: this.addCommunityForm.id,
              address: this.addCommunityForm.address,
              orgid: this.addCommunityForm.orgid,
              lng: parseFloat(this.addCommunityForm.lng),
              lat: parseFloat(this.addCommunityForm.lat),
              zone_type: this.addCommunityForm.zone_type,
              name: this.addCommunityForm.name
            }
            addorgcommunity(data).then(res => {
              if (data.zone_type === 1) {
                this.$notify({
                  title: '成功',
                  message: '成功新建小区',
                  type: 'success',
                  duration: 2000
                })
              } else {
                this.$notify({
                  title: '成功',
                  message: '成功新建机构',
                  type: 'success',
                  duration: 2000
                })
              }
              if (this.$route.path === '/community') {
                this.golobleObject.updateTableCommunity()
              }
              let obj = {
                type: 'isHomeAdd',
                communityObj: data
              }
              obj.communityObj.id = res.data.communityid
              this.$emit('getFatherCid', obj)
              this.$emit('change', false)
            }).catch(() => {
              if (data.zone_type === 1) {
                this.$notify.error({
                  title: '失败',
                  message: '新建小区失败'
                })
              } else {
                this.$notify.error({
                  title: '失败',
                  message: '新建机构失败'
                })
              }
            })
          } else {
            let data = {
              id: this.addCommunityForm.id,
              address: this.addCommunityForm.address,
              orgid: this.addCommunityForm.orgid,
              lng: parseFloat(this.addCommunityForm.lng),
              lat: parseFloat(this.addCommunityForm.lat),
              zone_type: this.addCommunityForm.zone_type,
              name: this.addCommunityForm.name
            }
            updateorgcommunity(data).then(res => {
              if (data.zone_type === 1) {
                this.$notify({
                  title: '成功',
                  message: '成功更新小区',
                  type: 'success',
                  duration: 2000
                })
              } else {
                this.$notify({
                  title: '成功',
                  message: '成功更新机构',
                  type: 'success',
                  duration: 2000
                })
              }
              this.golobleObject.updateTableCommunity()
              this.$emit('change', false)
            }).catch(() => {
              if (data.zone_type === 1) {
                this.$notify.error({
                  title: '失败',
                  message: '更新小区失败'
                })
              } else {
                this.$notify.error({
                  title: '失败',
                  message: '更新机构失败'
                })
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    sendMarkerLng () {
      if (this.addCommunityForm.lng !== 0 && this.addCommunityForm.lat !== 0) {
        let item = {
          lng: parseFloat(this.addCommunityForm.lng),
          lat: parseFloat(this.addCommunityForm.lat)
        }
        window.frames['mainIframe'].window.getParentAddress(item)
      }
    },
    sendMarkerLat () {
      if (this.addCommunityForm.lng !== 0 && this.addCommunityForm.lat !== 0) {
        let item = {
          lng: parseFloat(this.addCommunityForm.lng),
          lat: parseFloat(this.addCommunityForm.lat)
        }
        window.frames['mainIframe'].window.getParentAddress(item)
      }
    },
    selectMarker (item) {
      window.frames['mainIframe'].window.getParentAddress(item)
    },
    getIsAdd (obj) {
      if (obj.type === 'autoComplete') {
        this.autoComplete = obj.autoComplete
        if (!this.isAdd) {
          if (this.addCommunityForm.lng !== 0 && this.addCommunityForm.lat !== 0) {
            let item = {
              lng: this.addCommunityForm.lng,
              lat: this.addCommunityForm.lat
            }
            window.frames['mainIframe'].window.getParentAddress(item)
          }
        }
      } else if (obj.type === 'lnglat') {
        this.addCommunityForm.lng = obj.lng
        this.addCommunityForm.lat = obj.lat
      }
    }
  }
}
</script>

<style scoped>
  .container{
    height: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/communityAddEdit.vue